// `shortlist.change-state-dialogue.tpl.html` — "Any changes will be lost. Are you sure?"
//
// Shown by `exitEdit()` when the form is dirty, and by the ATS-filters modal for the same
// reason. The copy and the class names are verbatim: the stylesheet is scoped to
// `change-state-dialogue-container`, and the one sentence is what a recruiter recognises.
import type { ReactElement } from 'react'
import { UnifiedModal } from './UnifiedModal.tsx'

export interface ConfirmChangesDialogueProps {
  open: boolean
  /** `modalInstance.result` resolving — the Yes button. */
  onConfirm: () => void
  /** Its rejection — Cancel, the X, Escape and a backdrop click all land here. */
  onCancel: () => void
}

export function ConfirmChangesDialogue({ open, onConfirm, onCancel }: ConfirmChangesDialogueProps): ReactElement {
  return (
    <UnifiedModal open={open} windowClass="dialog-unified shortlist-dialogue change-state-dialogue-container" onClose={onCancel}>
      <div>
        {/* ⚠️ THE BODY HAS ITS OWN X, SEPARATE FROM THE SHELL'S. Upstream renders both — the
            header's `.close` from the unified template and this `.shortlist-dialogue-x-icon`
            from the dialogue's own body — and the stylesheet hides one of them. Dropping it
            here would be a change the stylesheet cannot undo. */}
        <div className="shortlist-dialogue-x-icon">
          <i className="far fa-times" onClick={onCancel} />
        </div>
        <div className="change-state-dialogue-cta">
          <span>Any changes will be lost. Are you sure?</span>
        </div>
        <div className="shortlist-dialogue-actions">
          <div>
            {/* `click-and-disable` upstream: the button disables itself for the duration of
                the handler, so a double-click cannot resolve the promise twice. */}
            <button type="button" onClick={onConfirm}>
              Yes
            </button>
          </div>
          <div>
            <a href="" onClick={(event) => { event.preventDefault(); onCancel() }}>
              Cancel
            </a>
          </div>
        </div>
      </div>
    </UnifiedModal>
  )
}
